import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation,Link } from "react-router-dom";
import { useAuthContext } from "../../contexts/authContext";
import Footer from "./Footer";

export default function SideNav({ children, ...rest }) {
  const { username } = useAuthContext();
  const location = useLocation();

  function navLinkClass(path) {
    return location.pathname === path ? "nav-link active" : "nav-link";
  }

  return (
    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-light"
          id="sidenavAccordion"
        >
          <div className="sb-sidenav-menu">
            <div className="nav">
              <div className="sb-sidenav-menu-heading">System</div>

              
              <Link className={navLinkClass("/engines")} to="/engines">
                <div className="sb-nav-link-icon">
                  <FontAwesomeIcon icon="chart-bar" />
                </div>
                Analysis Engines 
              </Link>
              <Link className={navLinkClass("/training")} to="/training">
                <div className="sb-nav-link-icon">
                  <FontAwesomeIcon icon="database" />
                </div>
                Training Data
              </Link>
              <Link
                className={navLinkClass("/configuration")}
                to="/configuration"
              >
                <div className="sb-nav-link-icon">
                  <FontAwesomeIcon icon="cogs" />
                </div>
                Configuration
              </Link>
            </div>
          </div>
          <div className="sb-sidenav-footer">
            <div className="small">Logged in as:</div>
            {username}
          </div>
        </nav>
      </div>
      <div id="layoutSidenav_content">
        <main>
          <div className="container-fluid">{children}</div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
